// extracted by mini-css-extract-plugin
export default {"Chart":"commissionComparisonChart_Chart__6xlM5","hoverTextArray":"commissionComparisonChart_hoverTextArray__4eo4u"};